import { render, staticRenderFns } from "./psp-list.vue?vue&type=template&id=1d95f688&scoped=true"
import script from "./psp-list.vue?vue&type=script&lang=js"
export * from "./psp-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95f688",
  null
  
)

export default component.exports